import { render, staticRenderFns } from "./TitleLarge.vue?vue&type=template&id=3a409820&scoped=true&"
import script from "./TitleLarge.vue?vue&type=script&lang=js&"
export * from "./TitleLarge.vue?vue&type=script&lang=js&"
import style0 from "./TitleLarge.vue?vue&type=style&index=0&id=3a409820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a409820",
  null
  
)

export default component.exports